import {
  getSubmittalUserById,
  ProjectParticipants
} from "hooks/project-participants";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import {
  MUTATION_UPDATE_FEATURE_UNREGISTERED_USER_VENDOR_PARTICIPANT,
  MUTATION_UPDATE_FEATURE_USER_PARTICIPANT,
  UPDATE_FEATURE_COMPANY_PARTICIPANT
} from "entity-app/graphQL/ciq-feature-mutations";
import { gql } from "@apollo/client";
import { ProjectContext } from "context/ProjectProvider";
import { useContext } from "react";
import {
  CompanyParticipationType,
  UserParticipationType
} from "../../constants";

export function useUpdateUserParticipants(
  WFProjectParticipants: ProjectParticipants
) {
  const { gqlClientForProject } = useContext(ProjectContext);

  const [mutationUpdateFeatureUnregisteredUserVendorParticipant] =
    useCIQMutation(
      gql(MUTATION_UPDATE_FEATURE_UNREGISTERED_USER_VENDOR_PARTICIPANT),
      {
        client: gqlClientForProject
      }
    );

  const [mutationUpdateFeatureCompanyParticipant] = useCIQMutation(
    gql(UPDATE_FEATURE_COMPANY_PARTICIPANT),
    {
      client: gqlClientForProject
    }
  );

  const [mutationUpdateFeatureUserParticipant] = useCIQMutation(
    gql(MUTATION_UPDATE_FEATURE_USER_PARTICIPANT),
    {
      client: gqlClientForProject
    }
  );

  async function updateFeatureUserParticipant(params: {
    userId: string;
    userParticipationType: UserParticipationType;
    featureInstanceId: string;
  }) {
    const { userId, featureInstanceId, userParticipationType } = params;

    const foundUser = WFProjectParticipants.allProjectUsersMap[userId];

    let variables: any = {};

    if (foundUser && foundUser.type === "poc") {
      variables = {
        featureInstanceId,
        user_participation_type_id: userParticipationType,
        object: {
          instance_id: featureInstanceId,
          user_unregistered: userId,
          user_participation_type_id: userParticipationType
        }
      };
    } else {
      variables = {
        featureInstanceId,
        user_participation_type_id: userParticipationType,
        object: {
          instance_id: featureInstanceId,
          user_id: userId,
          user_unregistered: null,
          user_participation_type_id: userParticipationType
        }
      };
    }

    const updateResponse = await mutationUpdateFeatureUserParticipant({
      variables
    });

    return updateResponse;
  }
  async function updateUserAndCompany(params: {
    userId: string;
    featureInstanceId: string;
    projectParticipants: any;
  }) {
    const { userId, featureInstanceId, projectParticipants } = params;

    const foundUser = getSubmittalUserById(userId, projectParticipants);

    let variables: any = {};

    let mutationUpdateResponse: any = {};

    if (foundUser && foundUser.type === "poc") {
      variables = {
        featureInstanceId,
        user_participation_type_id: UserParticipationType.DESIGN_REVIEWER,
        company_participation_type_id:
          CompanyParticipationType.DESIGN_REVIEWER_VENDOR,
        insertUserObject: {
          instance_id: featureInstanceId,
          user_unregistered: userId,
          user_participation_type_id: UserParticipationType.DESIGN_REVIEWER
        },
        insertCompanyObjects: [
          {
            instance_id: featureInstanceId,
            company_participation_type_id:
              CompanyParticipationType.DESIGN_REVIEWER_VENDOR,
            vendor_unregistered: foundUser?.company?.name
          }
        ]
      };

      mutationUpdateResponse =
        await mutationUpdateFeatureUnregisteredUserVendorParticipant({
          variables
        });
    } else {
      variables = {
        featureInstanceId,
        user_participation_type_id: UserParticipationType.DESIGN_REVIEWER,
        object: {
          instance_id: featureInstanceId,
          user_id: userId,
          user_unregistered: null,
          user_participation_type_id: UserParticipationType.DESIGN_REVIEWER
        }
      };

      await mutationUpdateFeatureCompanyParticipant({
        variables: {
          instance_id: featureInstanceId,
          company_participation_type_id:
            CompanyParticipationType.DESIGN_REVIEWER_VENDOR,
          objects: [
            {
              instance_id: featureInstanceId,
              company_participation_type_id:
                CompanyParticipationType.DESIGN_REVIEWER_VENDOR,
              vendor_unregistered: null
            }
          ]
        }
      });

      mutationUpdateResponse = await mutationUpdateFeatureUserParticipant({
        variables
      });
    }

    return mutationUpdateResponse;
  }

  return {
    updateUserAndCompany,
    updateFeatureUserParticipant
  };
}
